import {
    initializeApp } from "firebase/app";
import { deleteToken,
    getMessaging,
    getToken,
    isSupported,
    onMessage } from "firebase/messaging";
import {
  printDebugLog
} from "./constants/constant";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

let messaging = null;

export async function getFCMServiceWorkerRegistration() {
    if (!("serviceWorker" in navigator)) return null;
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", { scope: "/" });
    await navigator.serviceWorker.ready;
    return registration;
}

export async function initMessaging() {
    const supported = await isSupported();
    if (!supported) {
        console.warn("FCM Web Push is NOT supported on this browser.");
        return null;
    }

    messaging = getMessaging(app);
    return messaging;
}


export const requestFCMToken = async (serviceWorkerRegistration) => {
    try {
        const messaging = await initMessaging();
        if (!messaging) {
            console.log("Push notifications disabled for this device/browser.");
            return;
        }
        const registration = serviceWorkerRegistration || await getFCMServiceWorkerRegistration();
        if (!registration) return;
        const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration,
        });
        return token;
    } catch (error) {
        console.error("Error getting FCM token:", error);
    }
};

export const listenForForegroundMessages = async (cb) => {
    const messaging = await initMessaging();
    if (!messaging) {
        console.log("Push notifications disabled for this device/browser.");
        return;
    }
    return onMessage(messaging, (payload) => {
        printDebugLog("Foreground message:", payload);
        if (cb) cb(payload);
    });
};

export async function unsubscribeFCM() {
    try {
        const messaging = await initMessaging();
        if (!messaging) {
            console.log("Push notifications disabled for this device/browser.");
            return;
        }
        const registration = await getFCMServiceWorkerRegistration();
        const currentToken = registration ? await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration,
        }) : null;

        if (currentToken) {
            await deleteToken(messaging);
            console.log("FCM token deleted successfully, unsubscribed!");
        } else {
            console.log("No FCM token to delete");
        }
    } catch (error) {
        console.error("Error unsubscribing:", error);
    }
}
